// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { APIContext, Confirmation, withConfirmation } from 'speed-js-react';
import { HTTP_400_BAD_REQUEST, HTTP_401_UNAUTHORIZED, HTTP_403_FORBIDDEN } from 'speed-js-core/src/api/constants';

type Props = {
    confirm: (confirmation: Confirmation) => void,
};

const ApiClientErrorHandler = (props: Props) => {
    const { confirm } = props;
    const allowedErrorStatusCodes = [HTTP_401_UNAUTHORIZED, HTTP_403_FORBIDDEN];

    const { apiClient } = React.useContext(APIContext);

    const invokeErrorDialog = React.useCallback((errorMessage) => confirm({
        message: errorMessage,
        actions: {
            cancel: {
                label: <FormattedMessage id="cancel-delete-btn" defaultMessage="Cancel" />,
                callback: () => window.location.reload(),
                type: 'negative',
            },
        },
    }), [confirm]);

    const handleNewErrorMessage = React.useCallback((error) => {
        if (allowedErrorStatusCodes.includes(error.status)) {
            const errorMessage = error?.data?.detail || error?.data?.error || error?.data?.non_field_errors;
            if (errorMessage) {
                invokeErrorDialog(errorMessage);
            }
        }
    }, [invokeErrorDialog, allowedErrorStatusCodes]);

    React.useEffect(() => {
        apiClient.subscribe('failure', handleNewErrorMessage);
        return () => apiClient.unsubscribe('failure', handleNewErrorMessage);
    }, [apiClient, handleNewErrorMessage]);

    return null;
};

export default withConfirmation(ApiClientErrorHandler);
